import React from 'react'
import { useTranslation } from 'react-i18next'

function OrderOverviewStatusTooltip() {

  const { t } = useTranslation();

  return (

    <span class='element ml-1'>
      <svg
        width='18'
        height='18'
        fill='none'
        className='inline'
      >
        <path
          d='M9 0C4.036 0 0 4.036 0 9s4.036 9 9 9 9-4.036 9-9-4.036-9-9-9Zm0 1.2A7.79 7.79 0 0 1 16.8 9c0 4.315-3.485 7.8-7.8 7.8A7.79 7.79 0 0 1 1.2 9 7.79 7.79 0 0 1 9 1.2ZM9 4C7.35 4 6 5.35 6 7a.6.6 0 1 0 1.2 0C7.2 5.999 8 5.2 9 5.2S10.8 6 10.8 7c0 .623-.251 1.048-.663 1.481-.411.434-.982.826-1.512 1.25a.6.6 0 0 0-.225.47V11a.6.6 0 1 0 1.2 0v-.506c.437-.334.95-.701 1.412-1.188C11.551 8.74 12 7.974 12 7c0-1.65-1.35-3-3-3Zm0 8.4A.8.8 0 1 0 9 14a.8.8 0 0 0 0-1.6Z'
          fill='#231F20'
        />
      </svg>
      <div
        className='statustooltip tooltip-status absolute bg-white h-auto rounded-sm status-checked text-[12px] w-auto z-10'
      >
        <div className='flex flex-row font-normal pb-1 pt-1'>
          <ul>
            <li className='cancelled-pending pb-2.5'>
              <div className='flex'>
                <svg width='20' height='20' fill='none'>
                  <g
                    clipPath='url(#clip0_4811_197315)'
                    stroke='#E2211C'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  >
                    <path d='m12.5 7.5-5 5M7.5 7.5l5 5M18.334 9.232v.766a8.334 8.334 0 1 1-4.942-7.616' />
                  </g>
                  <defs>
                    <clipPath id='clip0_4811_197315'>
                      <rect
                        width='20'
                        height='20'
                        fill='#fff'
                      />
                    </clipPath>
                  </defs>
                </svg>
                <p className='font-normal ml-2'>
                  {t("CancellationPending")}
                </p>
              </div>
            </li>
            <li className='cancelled pb-2.5 '>
              <div className='flex'>
                <svg width='20' height='20' fill='none'>
                  <path
                    d='M15 5 5 15M5 5l10 10'
                    stroke='#E2211C'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
                <p className='font-normal ml-2'>
                  {t("Cancelled")}
                </p>
              </div>
            </li>
            <li className='pb-2.5 final-review'>
              <div className='flex'>
                <svg width='20' height='20' fill='none'>
                  <path
                    d='M13.333 3.332H15a1.667 1.667 0 0 1 1.666 1.667v11.666A1.667 1.667 0 0 1 15 18.332H5a1.667 1.667 0 0 1-1.667-1.667V5A1.667 1.667 0 0 1 5 3.332h1.666'
                    stroke='#595959'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    d='M12.5 1.668h-5a.833.833 0 0 0-.833.833v1.667c0 .46.373.833.833.833h5c.46 0 .834-.373.834-.833V2.501a.833.833 0 0 0-.834-.833Z'
                    stroke='#595959'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
                <p className='font-normal ml-2'>
                  {t("FinalReview")}

                </p>
              </div>
            </li>

            <li className='needs-approval pb-2.5'>
              <div className='flex'>
                <svg width='20' height='20' fill='none'>
                  <g
                    clipPath='url(#clip0_4811_197272)'
                    stroke='#595959'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  >
                    <path
                      d='M10 18.335a8.333 8.333 0 1 0 0-16.667 8.333 8.333 0 0 0 0 16.667Z'
                      strokeWidth='1.5'
                    />
                    <path
                      d='M10 6.668v3.333M10 13.332h.009'
                      strokeWidth='2'
                    />
                  </g>
                  <defs>
                    <clipPath id='clip0_4811_197272'>
                      <rect
                        width='20'
                        height='20'
                        fill='#fff'
                      />
                    </clipPath>
                  </defs>
                </svg>
                <p className='font-normal ml-2'>
                  {t("NeedsApproval")}

                </p>
              </div>
            </li>
            <li className='not-submitted pb-2.5'>
              <div className='flex'>
                <svg width='20' height='20' fill='none'>
                  <path
                    d='M4.167 10h11.667'
                    stroke='#595959'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
                <p className='font-normal ml-2'>
                  {t("NotYetSubmitted")}

                </p>
              </div>
            </li>
            <li className='pb-2.5 ready-for-pickup'>
              <div className='flex'>
                <svg width='20' height='20' fill='none'>
                  <path
                    d='M16.666 5 7.5 14.167 3.333 10'
                    stroke='#09B505'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
                <p className='font-normal ml-2'>
                  {t("ReadyforPickup")}

                </p>
              </div>
            </li>
            <li className='pb-2.5 under-review'>
              <div className='flex'>
                <svg width='20' height='20' fill='none'>
                  <g
                    clipPath='url(#clip0_4811_197280)'
                    stroke='#595959'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  >
                    <path d='M9.167 3.332H3.334a1.667 1.667 0 0 0-1.667 1.667v11.666a1.667 1.667 0 0 0 1.667 1.667H15a1.667 1.667 0 0 0 1.667-1.667v-5.833' />
                    <path d='M15.417 2.084a1.768 1.768 0 0 1 2.5 2.5L10 12.501l-3.333.833.833-3.333 7.917-7.917Z' />
                  </g>
                  <defs>
                    <clipPath id='clip0_4811_197280'>
                      <rect
                        width='20'
                        height='20'
                        fill='#fff'
                      />
                    </clipPath>
                  </defs>
                </svg>
                <p className='font-normal ml-2'>
                  {t("UnderReview")}

                </p>
              </div>
            </li>
            <li className='pb-2.5 waiting-for-info'>
              <div className='flex'>
                <svg width='20' height='20' fill='none'>
                  <g
                    clipPath='url(#clip0_4811_197264)'
                    stroke='#595959'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  >
                    <path d='M10 18.335a8.333 8.333 0 1 0 0-16.667 8.333 8.333 0 0 0 0 16.667ZM8.333 12.5v-5M11.667 12.5v-5' />
                  </g>
                  <defs>
                    <clipPath id='clip0_4811_197264'>
                      <rect
                        width='20'
                        height='20'
                        fill='#fff'
                      />
                    </clipPath>
                  </defs>
                </svg>
                <p className='font-normal ml-2'>
                  {t("WaitingForInformation")}

                </p>
              </div>
            </li>
            <li className='pb-2.5 waiting-for-info'>
              <div className='flex'>
                <svg width="20" height="20" fill="none">
                  <g
                    stroke="#595959"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="10" cy="10" r="8.333" />
                    <path d="M10 5.833v4.167l2.5 2.5" />
                  </g>
                </svg>
                <p className='font-normal ml-2'>
                  {t("IDVPending")}

                </p>
              </div>
            </li>



            {/* <li className='pb-2.5 review-complete'>
              <div className='flex'>
                <svg width='20' height='20' fill='none'>
                  <path
                    d='m7.5 9.165 2.5 2.5 8.333-8.333'
                    stroke='#595959'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    d='M17.5 10v5.833a1.666 1.666 0 0 1-1.667 1.667H4.167A1.667 1.667 0 0 1 2.5 15.833V4.167A1.667 1.667 0 0 1 4.167 2.5h9.166'
                    stroke='#595959'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
                <p className='font-normal ml-2'>
                  Review complete
                </p>
              </div>
            </li>
            <li className='ctic-ready pb-2.5'>
              <div className='flex'>
                <svg width='20' height='20' fill='none'>
                  <g
                    clipPath='url(#clip0_4811_197294)'
                    stroke='#09B505'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  >
                    <path d='M18.334 9.232v.766a8.334 8.334 0 1 1-4.942-7.616' />
                    <path d='M18.333 3.332 10 11.674l-2.5-2.5' />
                  </g>
                  <defs>
                    <clipPath id='clip0_4811_197294'>
                      <rect
                        width='20'
                        height='20'
                        fill='#fff'
                      />
                    </clipPath>
                  </defs>
                </svg>
                <p className='font-normal ml-2'>
                  CTIC Ready for pickup
                </p>
              </div>
            </li>
           
            <li className='pb-2.5 picked-up'>
              <div className='flex'>
                <svg width='20' height='20' fill='none'>
                  <path
                    d='M17.5 6.668v10.833h-15V6.668M19.166 2.5H.833v4.167h18.333V2.5ZM8.333 10h3.333'
                    stroke='#27BD23'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
                <p className='font-normal ml-2'>
                  Picked up
                </p>
              </div>
            </li> */}

          </ul>
        </div>
      </div>
    </span>
  )
}

export default OrderOverviewStatusTooltip
